import { CDN_CLRSAVE_URL } from '../../constants';
export const NACH_FORM_URL = `${CDN_CLRSAVE_URL}/clearsave-frontend/images/blanknachform.pdf`;
export const SAMPLE_MANDATE_FORM = `${CDN_CLRSAVE_URL}/clearsave-frontend/images/sample-upload-mandate-form.pdf`;

export const MANDATE_FAQS = [
  {
    question: 'What is Auto-pay?',
    answer:
      "Auto-pay is a one-time registration through which you instruct the bank to deduct a specified amount of money from your account towards investing into a SIP portfolio. Once you register for Auto-pay, you don't have to follow the payment process every time you invest in the SIP",
  },
  {
    question: 'How can I delete the Auto-pay?',
    answer:
      'You can delete the Auto-pay by going to Profile and clicking the “Bank and Auto-pay” option. You can select the Auto-pay you may want to delete. It takes us 24-48 hours to process your ',
  },

  {
    question: 'How can I increase the Auto-pay limit?',
    answer:
      'Auto-pay limit cannot be increased. You will have to setup a fresh Auto-pay again',
  },
  {
    question: 'How can I change the bank account on which the Auto-pay is set?',
    answer:
      'You cannot change the current Auto-pay. However you can cancel this Auto-pay and set up a new Auto-pay from your new verified bank account.',
  },
  {
    question: 'What will happen to Auto-pays when I change my bank account?',
    answer:
      'You have to cancel your current Auto-pay and set up the new Auto-pay from the preferred bank account. You need to first add the new bank details on the app by navigating to the Profile and selecting the “Bank and Auto-pay” option. Once the bank account is verified you can set up the new Auto-pay.',
  },
];

export const signatureImages = [
  {
    img: `/clearsave-frontend/images/NACH_correct_signature.jpg`,
    correct: true,
  },
  {
    img: `/clearsave-frontend/images/NACH_wrong_signature_1.jpg`,
    correct: false,
  },
  {
    img: `/clearsave-frontend/images/NACH_wrong_signature_2.jpg`,
    correct: false,
  },
];

export const checkPoints = [
  {
    title: 'Signature on the form',
    subtitle:
      'Please take care of the following points while making the signature. Signature should be:',
    points: [
      'same signature as per bank records',
      `above your name on the form [(view sample)](${SAMPLE_MANDATE_FORM})`,
      'large and clear, made on the correct form',
    ],
  },
  {
    title: 'Taking the picture of the signed form',
    subtitle:
      'Kindly consider the following points when taking the picture of the signed form:',
    points: [
      'form should have a white background',
      'you may use a scanner or mobile scanner',
      'picture should be taken in good lighting',
      'picture should have NO Shadows',
    ],
  },
  {
    title: 'Bank authorization',
    subtitle:
      'The completed mandate form is sent for authorization by your bank.',
  },
  {
    title: 'Bank charges',
    subtitle:
      'Depending upon your bank, you may be charged a one-time processing fee for this mandate.',
  },
];

export const steps = [
  {
    title: '1. Download the pre-filled form',
  },
  {
    title: '2. Print and sign the form',
    subtitle:
      'Please ensure same signature as in bank records Sign above your name on the form. <a href="https://assets1.cleartax-cdn.com/clearsave-frontend/images/sample-upload-mandate-form.pdf" target="_blank">VIEW SAMPLE</a>',
  },
  {
    title: '3. Upload signed form in .jpg or .jpeg',
    subtitle:
      'Please ensure form has a white background, no shadows and good lighting. We recommend using <a href="https://play.google.com/store/apps/details?id=com.intsig.camscanner&hl=en_IN" target="_blank">CamScanner</a> for scanning.',
  },
];

export const REJECTED = 'REJECTED';

export const TPSL = 'TPSL';
export const BILLDESK = 'BILLDESK';

export const BANK_LIST = [
  { label: 'Axis Bank', value: 'UTI' },
  { label: 'Andhra Bank', value: 'AND' },
  { label: 'Bank of Baroda', value: 'BBR' },
  { label: 'Bank of Maharashtra', value: 'BOM' },
  { label: 'Canara Bank', value: 'CNB' },
  { label: 'Central Bank of India', value: 'CBI' },
  { label: 'Citibank', value: 'CITI' },
  { label: 'City Union Bank', value: 'CUB' },
  { label: 'Deutsche Bank', value: 'DBK' },
  { label: 'Equitas Small Finance Bank', value: 'EQB' },
  { label: 'Federal Bank', value: 'FBK' },
  { label: 'HDFC Bank', value: 'HDF' },
  { label: 'ICICI Bank', value: 'ICI' },
  { label: 'IDBI', value: 'IDB' },
  { label: 'IDFC FIRST Bank', value: 'IDN' },
  { label: 'Indian Overseas Bank', value: 'IOB' },
  { label: 'IndusInd Bank', value: 'IDS' },
  { label: 'KARNATAKA BANK LIMITED', value: 'KARB' },
  { label: 'Kotak Mahindra Bank', value: '162' },
  { label: 'Oriental Bank Of Commerce', value: 'OBC' },
  { label: 'Paytm Payments Bank', value: 'PPB' },
  {
    label: 'Punjab National Bank - Retail Banking',
    value: 'PNB',
  },
  { label: 'RBL Bank', value: 'RBL' },
  { label: 'South Indian Bank', value: 'SIB' },
  { label: 'STANDARD CHARTERED BANK', value: 'SCB' },
  { label: 'State Bank of India', value: 'SBI' },
  { label: 'Tamilnadu Mercantile Bank', value: 'TMB' },
  { label: 'UNION BANK OF INDIA', value: 'UBI' },
  { label: 'Ujjivan Small Finance Bank', value: 'ujjivanSmallFinanceBank' },
  { label: 'Yes Bank', value: 'YBK' },
  { label: 'BANK OF INDIA', value: 'BOI' },
];

// bank code be same as BANK_LIST.value
export const MAP_BANK_TO_PAYMENT = {
  AND: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  UTI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  BBR: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  BOM: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  CNB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  CBI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  CITI: {
    netBanking: false,
    debitCard: false,
    paper: true,
  },
  CUB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  DBK: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  EQB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  FBK: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  HDF: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  ICI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  IDB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  IDN: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  IOB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  IDS: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  KARB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  '162': {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  OBC: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  PPB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  PNB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  RBL: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  SIB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  SCB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  SBI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  TMB: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  UBI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  ujjivanSmallFinanceBank: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  YBK: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
  BOI: {
    netBanking: true,
    debitCard: false,
    paper: true,
  },
};

export const MAP_INVESTMENTTYPE_TO_ORDERITEMTYPE = {
  SIP_MF: 'SIP_MF_ORDER_ITEM',
  LUMPSUM_MF: 'LUMPSUM_MF_ORDER_ITEM',
};



// WEBPACK FOOTER //
// ./constants/mandate/index.ts